import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class ProspectStatusService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/prospectStatuses`, options);
  }
}

export default ProspectStatusService;
